export default __webpack_public_path__ + "static/media/ax.87b55781.svg";